import { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import classNames from "classnames";
import Orders from "../../order/orders/orders.jsx";
const Coin_home = () => {
    const { slug_1 } = useParams();
    return (
        <>
            <Orders category_main='savings_orders' />
        </>
    );
}

export default Coin_home;
